<mat-toolbar color="primary">
  <mat-toolbar-row class="justify-content-end">
    <span>{{ userName }}</span>
    <div class="image-profile">
      <img [src]="buildImageUser()" class="image-profile__image" />
    </div>
    <span></span>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ "log_out" | translate }}</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
